import React, { useState } from 'react';
import { IconButton, Box } from '@mui/material';
import { DocumentsTableRow } from 'modules/customers/types';
import { GetApp } from '@mui/icons-material';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import { CreditAppDownloadWrapper } from '../../../../components/CreditAppDownloadWrapper';

interface Props {
  row: DocumentsTableRow;
}

export const DocumentsTableActionCell = ({ row }: Props) => {
  const [isCreditAppDownloading, setIsCreditAppDownloading] = useState(false);

  const handleView = () => {
    const currentPath = window.location.pathname + window.location.search + '#documents';
    window.open(`/document/${row.documentId}/${btoa(currentPath)}`, '_blank');
  };

  const handleDownloadCreditApplication = () => {
    setIsCreditAppDownloading(true);
  };

  return (
    <Box>
      {row.docType === 'Credit Application' && (
        <IconButton size="small" onClick={() => handleDownloadCreditApplication()}>
          <GetApp color="primary" />
        </IconButton>
      )}
      {row.source && (
        <IconButton size="small" href={row.source} target="_blank">
          <GetApp color="primary" />
        </IconButton>
      )}
      {row.documentId && (
        <IconButton size="small" onClick={() => handleView()}>
          <RemoveRedEyeIcon color="primary" />
        </IconButton>
      )}

      {isCreditAppDownloading && (
        <CreditAppDownloadWrapper
          voId={row.vendorOpportunityId}
          setIsCreditAppDownloading={setIsCreditAppDownloading}
        />
      )}
    </Box>
  );
};
